'use client';

import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { allPresetsAtom } from "./atoms/animationFormAtoms";
import { Preset } from '../../app/animate/[[...id]]/CreateAnimationTypes';

// Ensures full preset list is available to client components without needing to pass it around.
export default function PresetsInitializer({ presets }: { presets: Preset[]} ) {
    const setAllPresets = useSetAtom(allPresetsAtom);

    useEffect(() => {
        setAllPresets(presets);
    }, [presets, setAllPresets]);

    return null;
}